'use strict';

var Sugar = require('sugar-core'),
    ARRAY_OPTIONS = require('./var/ARRAY_OPTIONS');

var _arrayOptions = ARRAY_OPTIONS._arrayOptions;

module.exports = Sugar.Array.setOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/setOption.js
// module id = 421
// module chunks = 0